import useAjax from '../../Hooks/useAjax';
import axios from 'axios';
import { history } from '../../App';

// checks the course in the LTI session
// and validates it against the course in the URL
const validateCourse = course => {
  const urlPathSplit = window.location.pathname.split('/');
  const courseInUrl = urlPathSplit[1];
  return courseInUrl === course;
};

// used in CourseActions.js
// checks each block change to validate the session.
// if the session is expired, we redirect to /session-expired.
// if still valid, resets the session for another X minutes. (server configged)
export const checkLtiSession = async () => {
  const validationEndpoint =
    process.env.NODE_ENV === 'development'
      ? '/checkSessionTest.json'
      : '/checkSession/';
  let check = {};
  if (process.env.REACT_APP_SECURITY === 'lti') {
    check = await axios.get(validationEndpoint);
    // if we have a valid session, check to make sure
    // they are in the course they launched to.
    if (!check.data.valid) {
      history.replace(`${process.env.PUBLIC_URL}/invalid-session`, check.data);
    }
    // valid session, check the course
    if (check.data.valid && !validateCourse(check.data.course)) {
      // invalid course, redirect to message
      history.replace(`${process.env.PUBLIC_URL}/invalid-course`, check.data);
    }
    // valid everything.
    if (check.data.valid && validateCourse(check.data.course)) {
      return true;
    }
  } else {
    return true;
  }
};

// LTI security
const Lti = ({ app }) => {
  // check the endpoint for development vs prod build
  const validationEndpoint =
    process.env.NODE_ENV === 'development'
      ? '/validateLtiTest.json'
      : '/validateLTI/';
  // call endpoint
  const session = useAjax(validationEndpoint);
  // return nothing if we're waiting on the callback
  if (session === null) return '';
  // if the response doesn't have a `valid` prop or it's false...
  if (!session.valid) {
    history.replace(`${process.env.PUBLIC_URL}/invalid-session`, session);
  }

  // if we have a valid session, check to make sure
  // they are in the course they launched to.
  if (session.valid && !validateCourse(session.course)) {
    history.replace(`${process.env.PUBLIC_URL}/invalid-course`, session);
  }
  return app;
};

export default Lti;
